import { ADMIN_PERMISSIONS, AppTitleStrategy, AuthGuard } from '@app/core';
import { ChangePasswordComponent, UnauthenticatedComponent } from '@app/shared';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Route, RouterModule, TitleStrategy } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';

export const APP_ROUTES: Route[] = [
  { path: '', pathMatch: 'full', redirectTo: '/home' },
  // Old paths of the admin pages (bookmarks).
  { path: 'backend/sectors', pathMatch: 'full', redirectTo: '/admin/sectors' },
  { path: 'backend/users', pathMatch: 'full', redirectTo: '/admin/users' },
  {
    path: 'login',
    component: UnauthenticatedComponent,
    title: 'common.title.login',
  },
  {
    path: 'change-password',
    canActivate: [AuthGuard],
    data: { redirectTo: '/login' },
    component: ChangePasswordComponent,
    title: 'common.title.changePassword',
  },
  {
    path: 'search',
    canActivate: [AuthGuard],
    data: { redirectTo: '/login' },
    title: 'common.title.search',
    loadChildren: () =>
      import('./modules/search/search.module').then((m) => m.SearchModule),
  },
  {
    path: 'companies',
    canActivate: [AuthGuard],
    data: { redirectTo: '/login' },
    loadChildren: () =>
      import('./modules/companies/companies.module').then(
        (m) => m.CompaniesModule
      ),
  },
  {
    path: 'admin',
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      redirectTo: '/login',
      permissions: ADMIN_PERMISSIONS,
    },
    children: [
      {
        path: 'users',
        title: 'common.title.users',
        loadChildren: () =>
          import('./modules/backend/users/users.module').then(
            (m) => m.UsersModule
          ),
      },
      {
        path: 'sectors',
        title: 'common.title.sectors',
        loadChildren: () =>
          import('./modules/backend/sectors/sectors.module').then(
            (m) => m.SectorsModule
          ),
      },
    ],
  },
  // Home, /lists, the list pages (/lists/:listId), /alerts and /admin/lists;
  // also the redirects of the old /my-lists/... paths.
  {
    path: '',
    canActivate: [AuthGuard],
    data: { redirectTo: '/login' },
    loadChildren: () =>
      import('./modules/lists/lists.module').then((m) => m.ListsModule),
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(APP_ROUTES, { useHash: true, enableTracing: false }),
  ],
  providers: [
    AuthGuard,
    { provide: TitleStrategy, useClass: AppTitleStrategy },
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
